import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import VueQuillEditor from 'vue-quill-editor'
import {ServerTable, Event, ClientTable} from 'vue-tables-2';
import Notifications from 'vue-notification'
import vuexI18n from 'vuex-i18n'
import { messages } from './locale'
import './style/style.scss'
import { tokenHandler } from '@/client'
import { ModalPlugin } from './plugins/modal'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)
Vue.use(ModalPlugin)

Vue.use(Notifications)

var $ = require('jquery');
window.$ = $;
require('bootstrap');
Vue.use(VueQuillEditor)
Vue.use(ClientTable, {theme: "bootstrap"})
Vue.use(Event)
Vue.config.productionTip = false
Vue.use(vuexI18n.plugin, store)
Vue.i18n.add('fi', messages.fi)
Vue.i18n.add('en', messages.en)
Vue.i18n.add('sv', messages.sv)
Vue.i18n.add('svfi', messages.svfi)

Vue.i18n.set('fi')
Vue.use(VueResource)
Vue.use(tokenHandler, { store })
store.dispatch('loadSession')
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
